import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const StoreFranchiseIndicator = (_param)=> {
    var { className , label  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "label"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-franchise-indicator', className)
    }), label, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "franchise",
        className: "store-franchise-indicator__icon"
    }));
};
var StoreFranchiseIndicator$1 = StoreFranchiseIndicator;

export { StoreFranchiseIndicator$1 as default };
//# sourceMappingURL=StoreFranchiseIndicator.js.map
